import React from "react";
import CommonSendComponent from "../../components/CommonSendComponent";
import Menu from "../Menu";
import { SEND_CONFIGS } from "../../config/sendConfigs";

const SendFirmware = () => {
  return (
    <>
      <Menu />
      <CommonSendComponent config={SEND_CONFIGS.firmware} />
    </>
  );
};

export default SendFirmware;
